import { render, staticRenderFns } from "./DialogConfirmChangeAutorization.vue?vue&type=template&id=15887a92&scoped=true&"
import script from "./DialogConfirmChangeAutorization.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmChangeAutorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15887a92",
  null
  
)

export default component.exports